export class RecognitionFilter {
    idRecognition: number;
    ticketNumber: string;
    manualOpen: boolean;
    direction: number;
    startDate: Date;
    endDate: Date;
    licensePlate: string;
    lines: number[];
    status: number;
    serialNumber: string;
}
